/////////////////////////////////////////////////////////////////////
// Copyright (c) Autodesk, Inc. All rights reserved
// Written by Autodesk Design Automation team for Inventor
/////////////////////////////////////////////////////////////////////

import React, { Component } from 'react';
import { connect } from 'react-redux';
import Tabs, { Tab } from '@hig/tabs';
import ProjectList from './projectList';
import ForgeView from './forgeView';
import ParametersContainer from './parametersContainer';
import Bom from './bom';
//import Downloads from './downloads';
import Drawing from './drawing';
import './tabs.css';

import { embeddedModeEnabled, activeTabIndex } from '../reducers/mainReducer';
import { updateActiveTabIndex } from '../actions/uiFlagsActions';

const TabLabel = ({ children, active }) => (
    <span className={active ? 'customTabLabel active' : 'customTabLabel'}>
        {children}
    </span>
);

export class TabsContainer extends Component {
    onTabChange(index) {
        this.props.updateActiveTabIndex(index);
    }

    render() {
        const idx = this.props.activeTabIndex;
        const showProjectsTab = this.props.embeddedModeEnabled;
        const showParameters = this.props.embeddedModeEnabled;

        return (
            <div className="tabsContainer">
                <Tabs
                    className="fullheight customTabs"
                    align="center"
                    showTabDivider={false}
                    onTabChange={(index) => this.onTabChange(index)}
                    onTabClose={() => { }}
                    activeTabIndex={idx}
                >
                     {!showProjectsTab && (
                        <Tab label={<TabLabel active={idx === 0}>Projekty</TabLabel>}>
                            <div id="project-list" className="tabContent fullheight">
                                <ProjectList />
                            </div>
                        </Tab>
                    )} 

                    <Tab label={<TabLabel active={idx === 0}>Model</TabLabel>}>
                        <div id="model" className="tabContent fullheight">
                            <div className="inRow fullheight">
                                {!showParameters && <ParametersContainer />}
                                <ForgeView />
                            </div>
                        </div>
                    </Tab>

                    <Tab label={<TabLabel active={idx === 1}>BOM</TabLabel>}>
                        <div id="bom" className="tabContent fullheight">
                            <Bom />
                        </div>
                    </Tab>

                    <Tab label={<TabLabel active={idx === 2}>Rysunek</TabLabel>}>
                        <div id="drawing" className="tabContent fullheight">
                            <Drawing />
                        </div>
                    </Tab>

                    {/* <Tab label={<TabLabel active={idx === 3}>Do pobrania</TabLabel>}>
                        <div id="downloads" className="tabContent fullheight">
                            <Downloads />
                        </div>
                    </Tab> */}
                </Tabs>
            </div>
        );
    }
}

/* istanbul ignore next */
export default connect(
    (store) => ({
        activeTabIndex: activeTabIndex(store),
        embeddedModeEnabled: embeddedModeEnabled(store)
    }),
    { updateActiveTabIndex }
)(TabsContainer);